import css from './sass/alert.module.scss'

function PaymentAlertIcon(props) {

  return(
    <i className={`${css.alertBannerIcon} ${css.alertBannerIcon__paymentMethod}`}> </i>
  );
}

export default PaymentAlertIcon;